import { render, staticRenderFns } from "./404-mantainNew.vue?vue&type=template&id=6dce9713&scoped=true&"
import script from "./404-mantainNew.vue?vue&type=script&lang=ts&"
export * from "./404-mantainNew.vue?vue&type=script&lang=ts&"
import style0 from "./404-mantainNew.vue?vue&type=style&index=0&id=6dce9713&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dce9713",
  null
  
)

export default component.exports